import { render, staticRenderFns } from "./CField.vue?vue&type=template&id=72a882bf&scoped=true&"
import script from "./CField.vue?vue&type=script&lang=ts&"
export * from "./CField.vue?vue&type=script&lang=ts&"
import style0 from "./CField.vue?vue&type=style&index=0&id=72a882bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a882bf",
  null
  
)

export default component.exports